import {states} from './../constants/receipt-constants';
import {periodicityOptions as periodicities} from './../constants/periodicity-constants';

export class Receipt {
    constructor(
        uuid,
        consignment,
        member,
        createdAt,
        issueDate,
        amount,
        status,
        periodicity,
        type,
        code,
        memberCalled,
        chargeFromDate,
        chargedBy,
        chargedAt,
        receiptMemento,
        bankReturnDocumentHeaderDate
    ) {
        this.uuid = uuid;
        this.consignment = consignment;
        this.member = member;
        this.createdAt = createdAt;
        this.issueDate = issueDate;
        this.amount = amount;
        this.status = status;
        this.periodicity = periodicity;
        this.type = type;
        this.code = code;
        this.memberCalled = memberCalled;
        this.chargeFromDate = chargeFromDate;
        this.chargedBy = chargedBy;
        this.chargedAt = chargedAt;
        this.receiptMemento = receiptMemento;
        this.bankReturnDocumentHeaderDate = bankReturnDocumentHeaderDate
    }

    getStatusName() {
        let status = states.find(status => (status.key === this.status));
        return !!status ? status.value : null;
    }

    getPeriodicityName() {
        let periodicity = periodicities.find(periodicity => (periodicity.key === this.periodicity.name));
        return !!periodicity ? periodicity.value : null;
    }

    isBankType() {
        return ('BANK' === this.type);
    }

    isCollectorType() {
        return ('COLLECTOR' === this.type);
    }

    isReceiptType() {
        return ('RECEIPT' === this.type);
    }

    isCreatedStatus() {
        return ('CREATED' === this.status);
    }

    isPendingStatus() {
        return ('PENDING' === this.status);
    }

    isReturnedStatus() {
        return ('RETURNED' === this.status);
    }

    isChargeByBankStatus() {
        return ('CHARGE_BY_BANK' === this.status);
    }

    isChargedStatus() {
        return ('CHARGED' === this.status);
    }

    isEditable() {
        return ('RETURNED' === this.status
            || 'PENDING' === this.status
            || 'CHARGED' === this.status
            || 'CHARGE_BY_BANK' === this.status);
    }
}
